var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 505.2",
    style: {
      enableBackground: "new 0 0 270 505.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;}\n\t.st2{fill:#D0DE8E;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st4{fill:#FFEF44;}\n\t.st5{fill:#1F54B0;}\n\t.st6{fill:#D03632;}\n\t.st7{fill:#4C702B;}\n\t.st8{fill:none;stroke:#000000;stroke-width:0.57;stroke-dasharray:3.02,1.99,3.02,1.99,3.02,1.99;}\n\t.st9{fill:none;stroke:#000000;stroke-width:0.57;stroke-linecap:round;}\n\t.st10{fill:#93B838;}\n\t.st11{fill:#B1CC40;}\n\t.st12{fill:#CAF741;}\n\t.st13{fill:#FEF7CE;}\n\t.st14{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.8,450.5c1.6,2.5,4.6,1.9,7.5,4c3.1,2.3,5,5.7,6.5,9.7c-1.4,0.3-2,0.4-3.2,0.7c-1.5-3.6-2.8-6.2-4.9-7.7 c-3.1-2.1-6.5-0.8-8.9-5.2C177.8,451.5,178.2,451.3,179.8,450.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "194.7,478.8 191.4,468.8 194.7,468 198,477.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.9,448.5 144.8,386.1 147.1,383.1 178,446.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "171.8,448.8 173.5,449.3 179.7,446.2 180.3,444.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "174.7,454.5 175.2,452.7 181.4,449.6 183.1,450.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "188.7,470.7 189.6,469.1 196.4,467.6 197.9,468.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "187.2,464.5 188.8,465.4 195.5,463.8 196.4,462.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.5,303.2 145.2,379.1 142.8,382.2 104.4,304.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "140.2,383.5 142,383.2 146.3,377.8 146.1,376  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "143.8,389.3 143.6,387.5 147.9,382 149.7,381.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "112.9,105.6 128.5,130.7 125.2,132.8 109.6,107.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "112.6,42 158.9,14 156.8,10.5 110.5,38.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.2,40.7 86.2,54 88.1,57.2 109.3,44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "110,35.6 109.7,37.4 113.3,43.3 115.1,43.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "104.6,39 106.4,39.4 110.1,45.3 109.6,47.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "160.1,8.5 174.2,0 176.3,3.3 162.2,11.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "159.6,5.4 159.3,7.2 163,13.1 164.7,13.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "154.2,8.8 156,9.2 159.7,15.1 159.2,16.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146,468.4c-3.6,1.1-4.7,2.7-4.4,5.6c1.1,9.5,12.5,8.6,11.5,0.3C152.4,468.6,150,467.1,146,468.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.7,448.1c-1-8.6-5.5-8.6-10.8-7.9c-7.4,0.9-7.9,5.3-7,12s6.8,6.5,11.4,5.7 C150,457.1,152.4,454.7,151.7,448.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.4,401.1c-7.4-1.3-8.5,9-9.2,12.6s-2.6,14.2,5.3,15.1c6.9,0.8,8.6-9.1,9.1-13S144.7,402.4,137.4,401.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.7,475.5c0,2.1-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7c0,0,0,0,0,0 C150,471.8,151.7,473.4,151.7,475.5C151.7,475.5,151.7,475.5,151.7,475.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147.4,443.5c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7C145.7,439.7,147.4,441.4,147.4,443.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M137.9,422c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7C136.2,418.3,137.8,419.9,137.9,422 C137.9,422,137.9,422,137.9,422"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M140.5,407.4c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7S140.5,405.3,140.5,407.4L140.5,407.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M160.7,29.5c-10.8-4.3-20.8,5-27,9.6c-9.4,7-20.2,14.1-21.2,32c-0.8,14.6,4,25,11.4,36.3 c7.9,12,8.3,20,7.9,25.8c-0.4,8.7-8.8,10-12.3,19.8c-3.8,10.6-1,14.9-4,31s-11.6,24-11.4,63.3c0.1,13.4,1.5,33.3,5.3,49.1 s11.3,47.2,33,47.4c23.7,0.3,28.2-37,28.5-60.7c0.4-26.9-5.2-44.1-4.4-59c0.5-9.4,4.7-15.6,6.7-24.5c2-8.7-0.1-23,1.8-33.4 c2.1-11.6,3.9-16.3,6.9-32c1.7-9.1-0.6-18.4-6.1-25.8l-3.4-6.3c0,0,6.7-10.8,7.3-23.5c0.5-10.3-6.6-16.8-6.6-23.6 C173.3,42.4,172.3,34.1,160.7,29.5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "uebergang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M107.6,143.8l30.3-19.6 M138.9,128.2L108,148.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M140.2,122.9l16.4-10.3l12.9-7.4 M142.3,126.2l17-10.6l12-7.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "174.6,106.4 186.8,98.7 217.6,79.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "172.6,103.4 184.8,95.8 215.6,76.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "172,99.3 171.6,101.1 175.8,108.4 177.5,108.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "166.4,102.6 168.2,103 172.5,110.4 171.9,112.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "139.4,119.2 139,120.9 143.5,128.2 145.2,128.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "133.9,122.6 135.7,123 140.2,130.2 139.8,132  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M172.1,125.6c-5.9-6.3-30.1,7-35.9,19.4c-10.4,22.3-2.6,25.3-4.4,42.8c-0.9,8.8-9.8,16.1-11.2,45.2 c-0.8,15.5-0.8,31.1,0,46.6c1.3,21.4,9.5,24.9,19.1,24.9c13.6,0,16-12.6,15.6-19c-1.9-31.6-9.4-33.9-9-46.2 c0.7-21.5,10.8-19.9,16.1-45.9c3-14.7-1.9-18.3,2.9-36.3C169.9,139.9,178.1,131.9,172.1,125.6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M132.5,58.3c2.8-5.2,7.5-5.4,10.3-8.7c3.5-4.2,7.7-7.1,15.7-3.7c6.6,2.8,6.9,10,5.1,15.5 c-2,5.7-5.6,6.5-7.2,9.5s-1.1,18.9-12.5,18.1c-7.7-0.5-12.3-6.7-13.8-12.4C128.5,70.5,129.3,63.9,132.5,58.3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M134.1,60.1c3-5.5,6.9-5.3,9.8-8.3c2.6-2.7,4-4.5,7.9-4.8c5.1-0.3,10.5,2.6,10,9.5c-0.7,9.1-5.2,8.3-8.1,14 c-2.2,4.3-0.7,15.3-9.2,15.9c-4.4-0.1-8.4-2.6-10.3-6.6C131.4,74.2,130.7,66.4,134.1,60.1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M127.5,80.7c-2.5-0.3-7,1.9-7.1,4.7s2.6,4.7,3.5,6.7c1.9,4.1,2.9,7,6.7,5.5c3.4-1.4,4.3-3.9,1.2-9.3 C130.1,85.6,131.4,81.1,127.5,80.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M157,74.8c2.8-4.7,6.8-3.6,11.3-1.4c5,2.3,4.6,5.4,4.4,8.6s-1.1,8.7-2.5,10.8c-1.7,2.8-4.2,4-6.4,3.3 s-2.5-2.8-1.5-6.5c0.8-2.8,2-5.2-3-6.9C155.6,81.4,154.5,78.9,157,74.8"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.3,33L86.3,33C86.3,32.8,86.3,32.8,86.3,33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.7,125.1l0.7-2.7l-3.5-10.1l8.7-4.3l-7.3-8.1l-3-10.3L94.7,74.1l-3-10.8c0,0,1.2-11.4,1-11.6 c-1.8-2.3-4.6-5.8-5.8-5.8c-1.6,0-0.8-11.6-0.6-12.9c-0.4-0.3-7.6-8.7-7.5-8.5c-0.2,0.1-3.3,22-3.5,22.2l6,6.8l-7.8,8.1l-1.3,18.4 l12.8,20.7l-10.8,3.5l3.5,10.3l-1.5,11.3l-8.1,8.1l6.6,18.4l-8.6,4.8l-1,11.3l-9.1,6.6l-0.3,10.6c0.6,0.7,5.6-4,6.6-4 c1.1,0,2.1-0.6,2.7-1.5c0.6,1.6,2.4,2.5,4,1.9c1-0.3,1.7-1.2,2-2.2c0.4,0.2,0.8,0.3,1.2,0.2c1.7,0,3.2-1.4,3.2-3.1 c0-0.7-0.2-1.4-0.7-1.9c1.5-0.8,2.1-2.6,1.3-4.2c0,0,0-0.1,0-0.1c1.7-0.4,2.7-2.1,2.3-3.8c-0.1-0.4-0.3-0.8-0.6-1.2 c0.8-0.2,1.5-0.7,1.9-1.5c0.9,1.5,2.8,2,4.3,1.2c0.9-0.5,1.4-1.4,1.6-2.4c0.7,1.6,2.6,2.2,4.2,1.5c1.1-0.5,1.8-1.6,1.8-2.9 c0-0.3-0.1-0.7-0.2-1c0.5-0.2,1-0.6,1.4-1.1c0.6,0.5,1.3,0.7,2,0.7c1.7-0.1,3.1-1.5,3.1-3.2c0-1.2-0.8-2.3-1.9-2.8l1.8-4.2l8.7-3.9 l0.6-11.1l1-3.8c0.1,0,0.2,0,0.3,0c1.8,0,3.2-1.4,3.2-3.2C111.6,126.7,110.9,125.6,109.7,125.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M187.3,313.9c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2S187.3,312.1,187.3,313.9L187.3,313.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M126.8,330.7c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c0,0,0,0,0,0 C125.4,327.5,126.8,329,126.8,330.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M146.7,489.5c-0.2,0-0.4,0-0.6,0.1c-0.2-1.5-1.6-2.7-3.1-2.7c-1,0-1.9,0.4-2.4,1.2l-0.2-0.2 c0.6-0.6,0.9-1.4,0.9-2.2c0-1.7-1.4-3.1-3.1-3.1c-0.9,0-1.8,0.4-2.4,1.1l-5.1-4.7l-4.9-11.9c1.6-0.7,2.4-2.5,1.7-4.1 c-0.5-1.2-1.6-1.9-2.9-1.9c-0.3,0-0.6,0.1-0.9,0.1c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.4-3.1-3.2-3.1c-0.7,0-1.3,0.2-1.8,0.6l-5.7-6.1 c0.8-1.6,0.2-3.5-1.4-4.3c-1.6-0.8-3.5-0.2-4.3,1.4c0,0.1-0.1,0.1-0.1,0.2c-0.3-0.1-0.7-0.2-1-0.2c-1.7,0-3.2,1.4-3.2,3.1 c0,1.6,1.1,2.9,2.7,3.1c-1.6,0.6-2.5,2.4-1.8,4.1c0.5,1.2,1.6,2,2.9,2c0.2,0,0.3,0,0.5,0c-1.7,0.5-2.6,2.2-2.2,3.9 c0.4,1.4,1.6,2.3,3,2.3c0.6,0,1.3-0.2,1.8-0.6c0.2,0.2,0.4,0.5,0.6,0.7c-0.9,1.5-0.5,3.4,0.9,4.4c1.2,0.8,2.8,0.6,3.9-0.4 c0,0.1,0,0.2,0,0.4c0,1.7,1.4,3.1,3.2,3.1c1.5,0,2.7-1,3-2.4l3.2,1.3l-0.3,3.2c-0.2-0.1-0.5-0.1-0.7-0.1c-1.7,0-3.2,1.4-3.2,3.1 c0,1.7,1.4,3.2,3.1,3.2c1.2,0,2.3-0.6,2.8-1.7l2.5,1.5l-0.8,2.3c-0.3-0.1-0.7-0.2-1.1-0.2c-1.7,0-3.2,1.4-3.2,3.1 c0,0.6,0.2,1.2,0.5,1.6h-0.1c-1.7,0-3.1,1.4-3.1,3.2c0,1.7,1.4,3.1,3.1,3.1c0.3,0,0.5,0,0.8-0.1c0,0.2,0.1,0.4,0.2,0.6 c-1.6,0.6-2.5,2.4-1.9,4c0.6,1.6,2.4,2.5,4,1.9c0.6-0.2,1.1-0.6,1.5-1.1c0.1,1.7,1.5,3.1,3.2,3.1c1.5,0,2.7-1.1,3-2.5l8.2,0.6 c-0.1,0.2-0.1,0.4-0.1,0.7l1.4-7.2c0.5,0.3,1.1,0.5,1.7,0.5c1.8-0.1,3.1-1.6,3-3.4C149.7,490.9,148.4,489.6,146.7,489.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100,361.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C97.5,355.9,100,358.3,100,361.4C100,361.4,100,361.4,100,361.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M106.8,353.8c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C104.4,348.3,106.8,350.8,106.8,353.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.8,423.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C91.3,417.6,93.8,420,93.8,423.1C93.8,423.1,93.8,423.1,93.8,423.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.1,413.1c0,3-2.5,5.5-5.5,5.5S88,416.1,88,413c0-3,2.5-5.5,5.5-5.5C96.6,407.5,99.1,410,99.1,413.1 C99.1,413.1,99.1,413.1,99.1,413.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M104.6,423.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.4-5.5,5.5-5.5 C102,417.9,104.5,420.4,104.6,423.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.8,413.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C107.4,407.9,109.8,410.4,109.8,413.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M115.3,423.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C112.9,417.6,115.3,420,115.3,423.1C115.3,423.1,115.3,423.1,115.3,423.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M110.8,433.1c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C108.3,427.6,110.8,430,110.8,433.1 C110.8,433.1,110.8,433.1,110.8,433.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M114.4,443.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C111.9,438,114.4,440.4,114.4,443.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M118.6,433.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C116.1,428.1,118.5,430.5,118.6,433.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.1,444c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C120.6,438.5,123.1,441,123.1,444"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M120.8,453.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5 C118.3,447.8,120.8,450.3,120.8,453.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M131,472c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C128.5,466.5,131,468.9,131,472C131,472,131,472,131,472"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.4,463.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C121,458.2,123.4,460.7,123.4,463.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.3,456.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C127.8,451.1,130.3,453.6,130.3,456.6 C130.3,456.6,130.3,456.6,130.3,456.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M138,467.9c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C135.5,462.4,138,464.8,138,467.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M136.3,482.1c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5l0,0C133.8,476.5,136.3,479,136.3,482.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M124.8,481.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C122.3,476.1,124.8,478.6,124.8,481.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M141,476.6c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C138.5,471.1,141,473.5,141,476.6C141,476.6,141,476.6,141,476.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M145.2,499.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C142.7,494.1,145.2,496.6,145.2,499.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M141.2,490.9c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C138.8,485.3,141.2,487.8,141.2,490.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M155.6,496.2c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0 C153.1,490.7,155.6,493.2,155.6,496.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M204.4,492.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C201.9,486.6,204.4,489,204.4,492.1C204.4,492.1,204.4,492.1,204.4,492.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M201.5,482.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0 C199.1,477.1,201.5,479.6,201.5,482.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M216.3,428.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C213.8,423.2,216.3,425.6,216.3,428.7C216.3,428.7,216.3,428.7,216.3,428.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M214.2,419.4c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C211.7,413.9,214.2,416.4,214.2,419.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M179.2,424.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0 C176.8,419.2,179.2,421.7,179.2,424.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M177.4,417.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C174.9,412,177.3,414.5,177.4,417.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M210.8,395.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C208.3,390.2,210.8,392.6,210.8,395.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M203.2,350.2c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C200.8,344.7,203.2,347.2,203.2,350.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M198.1,333c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C195.7,327.5,198.1,329.9,198.1,333C198.1,333,198.1,333,198.1,333"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M94.9,404.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C92.4,399.2,94.9,401.7,94.9,404.7 C94.9,404.7,94.9,404.7,94.9,404.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.1,433.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C96.6,427.8,99.1,430.2,99.1,433.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M61.8,196.6c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C59.3,191.1,61.8,193.5,61.8,196.6 C61.8,196.6,61.8,196.6,61.8,196.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M62,204.2c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C59.5,198.7,62,201.1,62,204.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M79.6,374.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C77.1,369.2,79.6,371.6,79.6,374.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M85.1,385.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C82.6,379.6,85.1,382,85.1,385.1C85.1,385.1,85.1,385.1,85.1,385.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M89.4,393.2c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C87,387.7,89.4,390.2,89.4,393.2C89.4,393.2,89.4,393.2,89.4,393.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M73.2,364.9c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C70.7,359.3,73.2,361.8,73.2,364.9C73.2,364.8,73.2,364.8,73.2,364.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M70.7,360.9c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C68.2,355.4,70.7,357.8,70.7,360.9 C70.7,360.9,70.7,360.9,70.7,360.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.8,351.6c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C62.4,346.1,64.8,348.6,64.8,351.6 C64.8,351.6,64.8,351.6,64.8,351.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M79.8,227.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C77.4,222.1,79.8,224.6,79.8,227.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.1,251.3c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C84.7,245.8,87.1,248.3,87.1,251.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M126.1,322.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C123.6,317,126.1,319.5,126.1,322.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M119.1,312.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C116.7,307.2,119.1,309.7,119.1,312.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M124.6,315.2c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C122.1,309.7,124.6,312.2,124.6,315.2C124.6,315.2,124.6,315.2,124.6,315.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M113.7,301.9c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C111.2,296.3,113.7,298.8,113.7,301.9C113.7,301.8,113.7,301.8,113.7,301.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M167.5,239.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C165,234,167.5,236.5,167.5,239.5C167.5,239.5,167.5,239.5,167.5,239.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M170.9,246c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5S170.9,243,170.9,246 C170.9,246,170.9,246,170.9,246"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161.8,232.9c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5S161.8,229.9,161.8,232.9 C161.8,232.9,161.8,232.9,161.8,232.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M61.4,185.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C59,179.7,61.4,182.2,61.4,185.3C61.4,185.3,61.4,185.3,61.4,185.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M62,174.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C59.5,168.9,62,171.3,62,174.4 C62,174.4,62,174.4,62,174.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M71.7,179.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C69.2,174.2,71.7,176.6,71.7,179.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.7,173.2c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C78.3,167.6,80.7,170.1,80.7,173.2 C80.7,173.2,80.7,173.2,80.7,173.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91,168c0,3-2.5,5.5-5.5,5.5S80,171.1,80,168c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0C88.5,162.5,91,165,91,168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100.4,162.3c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C97.9,156.8,100.4,159.2,100.4,162.3C100.4,162.3,100.4,162.3,100.4,162.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M79.6,239.4c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C77.1,233.9,79.6,236.4,79.6,239.4C79.6,239.4,79.6,239.4,79.6,239.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M131.8,184.2c0,4.3-3.5,7.7-7.7,7.7s-7.7-3.5-7.7-7.7s3.5-7.7,7.7-7.7C128.4,176.5,131.8,180,131.8,184.2 L131.8,184.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.2,95c0,3-2.5,5.5-5.5,5.5S90.1,98,90.1,95s2.5-5.5,5.5-5.5h0C98.7,89.5,101.2,91.9,101.2,95 C101.2,95,101.2,95,101.2,95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M111.2,90.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C108.7,84.8,111.2,87.2,111.2,90.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M105.5,82.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C103,76.8,105.5,79.3,105.5,82.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M94.9,86.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C92.5,81.2,94.9,83.6,94.9,86.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M84.7,91c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C82.2,85.5,84.7,87.9,84.7,91C84.7,91,84.7,91,84.7,91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M78.1,81.6c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C75.6,76.1,78.1,78.5,78.1,81.6 C78.1,81.6,78.1,81.6,78.1,81.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.6,66.8c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C84.1,61.3,86.6,63.8,86.6,66.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.9,77.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C86.4,71.9,88.9,74.4,88.9,77.4C88.9,77.4,88.9,77.4,88.9,77.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.5,73.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h0C97,68.1,99.5,70.6,99.5,73.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77.7,71.6c0,3-2.5,5.5-5.6,5.5c-3,0-5.5-2.5-5.5-5.6c0-3,2.5-5.5,5.5-5.5C75.2,66,77.7,68.5,77.7,71.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M78.1,59.8c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0C75.6,54.3,78.1,56.8,78.1,59.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.7,47.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C78.3,41.8,80.7,44.3,80.7,47.4 C80.7,47.4,80.7,47.4,80.7,47.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.4,63.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C94,57.9,96.4,60.4,96.4,63.4C96.4,63.4,96.4,63.4,96.4,63.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.7,52.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0C97.2,46.8,99.7,49.2,99.7,52.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M88.3,55.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C85.8,49.8,88.3,52.2,88.3,55.3 C88.3,55.3,88.3,55.3,88.3,55.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.9,44.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C89.4,39,91.9,41.5,91.9,44.5 L91.9,44.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M82.1,36.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C79.6,30.9,82.1,33.3,82.1,36.4 C82.1,36.4,82.1,36.4,82.1,36.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M92.1,33.4c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5C89.6,27.9,92.1,30.3,92.1,33.4 C92.1,33.4,92.1,33.4,92.1,33.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M84.5,25c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0C82,19.5,84.5,22,84.5,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M115.7,122c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C113.2,116.5,115.7,119,115.7,122"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121.4,107.8c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C118.9,102.3,121.4,104.8,121.4,107.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M112.3,112.2c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C109.8,106.7,112.3,109.2,112.3,112.2C112.3,112.2,112.3,112.2,112.3,112.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M102.1,117.1c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h0C99.6,111.6,102.1,114.1,102.1,117.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M105.7,127c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5h0C103.2,121.5,105.7,124,105.7,127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M92.1,121.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C89.6,116.1,92.1,118.6,92.1,121.7 C92.1,121.7,92.1,121.7,92.1,121.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95.3,131.5c0,3-2.4,5.5-5.5,5.5c-3,0-5.5-2.4-5.5-5.5c0-3,2.4-5.5,5.5-5.5c0,0,0,0,0,0 C92.8,126,95.3,128.5,95.3,131.5L95.3,131.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M85.3,136.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C82.8,131.1,85.3,133.5,85.3,136.6C85.3,136.6,85.3,136.6,85.3,136.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M73.9,133.8c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C71.5,128.2,73.9,130.7,73.9,133.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M82.2,126.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C79.8,121.1,82.2,123.5,82.2,126.6 C82.3,126.6,82.3,126.6,82.2,126.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M73.2,120.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C70.7,114.8,73.2,117.3,73.2,120.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M83.4,114.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C80.9,109.1,83.4,111.6,83.4,114.7C83.4,114.7,83.4,114.7,83.4,114.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M79.8,104.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C77.3,98.8,79.8,101.2,79.8,104.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.8,110.5c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C91.3,105,93.8,107.5,93.8,110.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90.8,100.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C88.3,95.2,90.8,97.6,90.8,100.7C90.8,100.7,90.8,100.7,90.8,100.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M103.8,105.2c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h0C101.3,99.7,103.8,102.2,103.8,105.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M114.2,100.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5S114.2,97.1,114.2,100.1 C114.2,100.1,114.2,100.1,114.2,100.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M214.2,102.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C211.7,96.9,214.2,99.3,214.2,102.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M201.7,108c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0 C199.3,102.5,201.7,105,201.7,108"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M198.9,89.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5S198.9,86.1,198.9,89.1L198.9,89.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M194.7,94.2c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C192.3,88.7,194.7,91.2,194.7,94.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M219.7,78.6c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C217.2,73,219.7,75.5,219.7,78.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M194.9,13.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C192.5,7.6,194.9,10.1,194.9,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M71.3,168c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C68.8,162.5,71.3,164.9,71.3,168C71.3,168,71.3,168,71.3,168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M81.3,161.9c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C78.8,156.4,81.3,158.9,81.3,161.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91,156.4c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C88.5,150.9,91,153.4,91,156.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.5,151.3c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5 C99,145.8,101.5,148.3,101.5,151.3L101.5,151.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M111.9,146.2c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C109.5,140.7,111.9,143.2,111.9,146.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M133.3,133.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5h0 C130.8,127.9,133.3,130.3,133.3,133.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M71.7,156.6c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C69.2,151.1,71.7,153.6,71.7,156.6 L71.7,156.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M81.9,151.1c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5S81.9,148.1,81.9,151.1L81.9,151.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M77,144.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C74.5,139.2,77,141.7,77,144.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.3,144.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C88.9,139.2,91.3,141.7,91.3,144.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.9,139.8c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C99.4,134.3,101.9,136.8,101.9,139.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M112.1,134.9c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0 C109.7,129.4,112.1,131.8,112.1,134.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M144.3,14.8c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5l0,0C141.8,9.3,144.3,11.8,144.3,14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M152.6,9.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C150.1,4.2,152.6,6.7,152.6,9.7C152.6,9.7,152.6,9.7,152.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M138.1,18.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5S138.1,15.6,138.1,18.7 C138.1,18.7,138.1,18.7,138.1,18.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M128.4,24.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C126,19,128.4,21.5,128.4,24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M118.4,30.4c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C115.9,24.8,118.4,27.3,118.4,30.4C118.4,30.3,118.4,30.3,118.4,30.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M104,41.9c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5l0,0C101.5,36.4,104,38.8,104,41.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M79.2,15.2c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c0,0,0,0,0,0 C76.8,9.7,79.2,12.2,79.2,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M68.1,14.8c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5c0,0,0,0,0,0 C65.6,9.3,68.1,11.8,68.1,14.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik5);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_5.99faa69f034169a7e029b18c008dc041.svg";
export { ForwardRef as ReactComponent };